export const VERIFICATION_CONTAINER_ID = 'verification-sdk-container';
